export default function AttachReportPackageReportFolderDirective() {
  return {
    template: require('./attach-report-package-report-folder.html'),
    scope: {
      reportPackageId: '=',
      reportFolder: '=',
    },
    controller: 'AttachReportPackageReportFolderController',
    controllerAs: 'attachReportPackageReportFolderVM',
    bindToController: true,
    replace: true
  };
}
